import NewspaperAdvancedView from './NewspaperAdvancedView'

export default NewspaperAdvancedView
